import React, { Fragment, useLayoutEffect, useState } from "react"

import { Button } from "components"
import { getOrderPrintData } from "utils"
import PlOrderPrintTemplateForKitchen from "components/PrintListener/PrinterTemplates/PlOrderPrintTemplateForKitchen"
import PlOrderPrintTemplateForCustomer from "components/PrintListener/PrinterTemplates/PlOrderPrintTemplateForCustomer"
import PlOrderInvoiceTemplate from "components/PrintListener/PrinterTemplates/PlOrderInvoiceTemplate"
import PlOrderLabelTemplate from "components/PrintListener/PrinterTemplates/PlOrderLabelTemplate"
import classes from "./index.module.scss"

const Print = () => {
  const [printType, setPrintType] = useState("")
  const [print, setPrint] = useState(null)

  const handlePrintPage = () => {
    window.print()
  }

  const getPrintDataFromSessionStorage = () => {
    const data =
      JSON.parse(
        sessionStorage.getItem("data") || "null"
      )

    if (data === null) return

    setPrintType(data.type)

    switch (data.type) {
      case "order":
      case "orderInvoice":
      case "courier": {
        const print = []

        data.value.forEach(order => {
          const printData =
            getOrderPrintData(order)

          print.push(printData)
        })

        setPrint(print)
      }

        break
      default:
    }
  }

  useLayoutEffect(() => {
    getPrintDataFromSessionStorage()
  }, [])

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        <Button
          onClick={handlePrintPage}
        >
          پرینت
        </Button>
      </div>
      {
        printType === "order" &&
        <Fragment>
          {print.map((printData, index) =>
            <Fragment key={index}>
              <PlOrderPrintTemplateForCustomer
                templateType="other"
                printData={printData}
              />
              <PlOrderPrintTemplateForKitchen
                templateType="other"
                printData={printData}
                thisPrinterOrderItems={printData.items}
              />
            </Fragment>
          )}
        </Fragment>
      }
      {
        printType === "orderInvoice" &&
        print.map((printData, index) =>
          <PlOrderInvoiceTemplate
            key={index}
            printData={printData}
          />
        )
      }
      {
        printType === "courier" &&
        print.map((printData, index) =>
          <PlOrderLabelTemplate
            key={index}
            printData={printData}
          />
        )
      }
    </div>
  )
}

export default Print